export default {
    meg: {
        username: 'username',
        email:'email',
        home:'Home',
        news:'Information',
        introduction:'Introduction',
        Product:'ODM product display',
        news:'NewsInformation',
        factory:'PlatformFactory',
        Entering:'Entering huizhiyi',
        person:'PersonalCenter',
        welcome:'welcome',
        logoout:'logoout',
        login:'Login | Registration',
        userlogin:'Login',
        userName:'Please enter username/email',
        Password:'Please enter password',
        forgotpassword:'forgotpassword',
        loginBtn:'Login Button',
        resgister:'Registered Account',
        progress:'Register a Huizhiyi account to place orders and track your orders, view order progress',
        customer:'Register Customer',
        manufacturer:'Register Manufacturer',
        resgisteruser:'I am a registered user, please go to',
        logBtn:'login',
        user:'userName',
        tephone:'phoneNumber',
        password:'Password',
        confirmPassword:'confirmPassword',
        code:'Eamil Code',
        contacts:'contacts',
        newproduct:'newProduct',
        viewProduct:'More Product',
        viewDetail:'viewDetail',
        positioning:'Platform Position',
        resources:'Integration of resources',
        urgent:'HZY Huizhi Garment Manufacturing Full Process Service Platform (hereinafter referred to as "HZY Platform") is an intelligent garment production Internet platform that focuses on accepting small and urgent orders and providing integrated services of production management, production monitoring and order delivery.',
        driven:'Resource driven',
        manufacturing:'The HZY platform aims to utilize new generation information technologies such as cloud computing, big data, Al intelligence, and the Internet of Things to integrate and drive order and production capacity resources, injecting new impetus and innovative models into the new demands of domestic and foreign textile and clothing production and manufacturing.',
        operation:'Platform operation mode',
        intelligent:'Building a full process service platform+MRIs 5G intelligent manufacturing system',
        application:'Integrated service and application platform for order management, production, and monitoring of Huizhiyi',
        process:'Platform operation process - ordering party',
        Services:'Platform Services',
        Efficient:'Efficient',
        small:'Efficient matching of small and urgent orders with parallel factories',
        ratio:'High cost performance ratio',
        cost:'High cost performance for small and urgent orders',
        monitoring:'Real time monitoring',
        visualization:'Real time visualization of production site during order production period',
        solutions:'Platform solutions',
        MRIssystem:'MRIs system',
        developed:'It is a brand new clothing production organization and management system independently developed by the platform, used to support the rapid and intelligent production of small and urgent orders in parallel factories under the HZY platform.',
        unit:'The MRIs system takes each employee as the production unit, intelligently generates virtual temporary production lines based on order requirements, and quickly completes the process of clothing production for each order. Make the order manufacturing process more convenient, standardized, and transparent.',
        Industrial:'Shandong Huizhiyi Industrial Technology Co., Ltd',
        Internet:'Shandong Huizhi Garment Industrial Technology Co., Ltd. is an industrial Internet company focusing on technological progress and industrial upgrading in the garment manufacturing industry.',
        research:'Shandong Huizhiyi Industrial Technology Co., Ltd. takes the industrial application research and development of AI intelligent technology as the lead, gathers profound clothing production and manufacturing resources and experience, develops and promotes the "MRIs Clothing Production Management System" with complete self intellectual property rights, and integrates long-term accumulated domestic and foreign clothing trade resources to build the "HZY Huizhiyi Clothing Manufacturing Full Process Service Platform", On the basis of comprehensively innovating the organization and management mode of clothing production and manufacturing, we strive to promote the formation of a new operating mode and industrial pattern in the clothing industry.',
        Clothing:'MRIs Clothing Production Management System',
        Full:'HZY - Huizhi Clothing Manufacturing Full Process Service Platform',
        perfectly:'The "HZY Huizhiyi Clothing Manufacturing Full Process Service Platform" under Shandong Huizhiyi Industrial Technology Co., Ltd. has achieved the integration of global clothing manufacturing orders and the production capacity of small and medium-sized clothing manufacturing enterprises through a new electronic trade model. The "MRIs Clothing Production Management System" has also been used to standardize and intelligentize the production capacity of clothing manufacturing, By using new technological means, the controllability and flexibility of the clothing processing industry chain can be perfectly combined, and the on-time rate, quality assurance rate, and safety of clothing manufacturing order circulation have been unprecedentedly guaranteed and improved.',
        future:'Shandong Huizhiyi Industrial Technology Co., Ltd. takes technology as its strength to fully adapt to the industry development trend of "small batch and multiple varieties", "small orders and quick returns", and "multiple parallel products" in the clothing manufacturing industry. With a new industry thinking and open industry perspective, it seeks new driving forces for industry development and expands the future new pattern of the industry.',
        order:'Order',
        inlet:'inlet',
        fac:'Factory',
        ACCOUNT:'ACCOUNT',
        personal:'Personal',
        myOrder:'MyOrder',
        MyCollection:'MyCollection',
        identity:'You have not been authenticated yet, please authenticate your identity as soon as possible',
        Certified:'Certified Customers',
        Certifieman:'Certified Manufacturer',
        Review:'Waiting for Review',
        Company:'Company Name',
        address:'address',
        Establishment:'Establishment',
        Number:'EmployeesNumber',
        Business:'BusinessType',
        ProductType:'ProductType',
        isseason:'isseasonType',
        saleType:'saleType',
        distribution:'DistributionChannel',
        annual:'annualSales',
        revenue:'AnnualSalesRevenue',
        processing:'processMethod',
        markets:'Markets',
        Profile:'Profile',
        license:'business license',
        uploaded:'Only jpg/png files can be uploaded',
        Applying:'Applying Certification',
        upload:'upload',
        plantArea:'plantArea',
        lines:'product lines',
        category:'ProcessCategory',
        output:'AnnualOutput',
        value:'AnnualValue',
        orderType:'orderType',
        facImg:'plantLogo',
        ImproveInformation:'ImproveInformation',
        back:'Back',
        Ordering:'OrderInformation',
        CustomerName:'CustomerName',
        contactsInformation:'ContactsInformation',
        CustomerType:'CustomerType',
        ordertt:'orderType',
        productiontype:'productiontype',
        producttype:'producttype',
        processtype:'processtype',
        pictures:'pictures',
        preparation:'preparation',
        view:'view',
        contract:'contract',
        PDF:'Only one PDF file can be uploaded, including instructions for surface materials, process, size table, key points, etc',
        total:'Quantity',
        totals:'total',
        color:'color',
        size:'size',
        quantity:'quantity',
        deletecolor:'deletecolor',
        addcolor:'addcolor',
        DeliveryInfo:'Delivery Information',
        arrivaltime:'arrivaltime',
        orderNum:'Order Number',
        deliveryType:'deliveryType',
        shippingtime:'shippingtime',
        destination:'destination',
        advance:'advance',
        Payment:'Payment Calculation Method',
        shipment:'shipment',
        balance:'balance',
        period:'account period',
        points:'Invoicing and tax points',
        general:'General ticket tax point',
        special:'Special ticket tax point',
        settlement:'Settlement',
        shipping:'ShippingMethod',
        price:'Intended target price',
        submit:'submit',
        productName:'productName',
        loginPage:'homepage',
        viewFactory:'More Factory',
        cutNum:'Cutting Number',
        sewing:'Sewing Number',
        packaging:'Packaging Number',
        quality:'Quality Number',
        contact:'Contact Person',
        Position:'Contact Position',
        information:'Contact Information',
        contactPhone:'Contact Phone',
        ContactEmail:'Contact Email',
        ContactWeChat:'Contact WeChat',
        ContactQQ:'Contact QQ',
        Registration:'Registration Information',
        Changepassword:'Change Password',
        confimChange:'Confirm Change',
        cancel:'cancel',
        orderList:'Order List',
        LetterIntent:'Letter Intent',
        whole:'whole',
        Toproduced:'To Produced',
        Production:'Produced',
        finished:'Finished',
        Detail:'Detail',
        Serial:'Serial Number',
        Operation:'Operation',
        receiveOrder:'Receive Order',
        prog:'Process',
        collect:'Collect List',
        Cancelcollect:'Cancel Collect',
        today:'today',
        DeliveryDate:'Delivery Date',
        remark:'remark',
        feedback:'Production Feedback',
        message:'Message',
        messageList:'Message List',
        status:'status',
        search:'search',
        reset:'reset',
        read:'Read',
        unread:'Unread',
        markRead:'Mark as Read',
        hzy:'Hui Zhiyi',
        Inspection:'Inspection',
        money:'Currency',
        Trendy:'Hui Intelligent Manufacturing System for World Trendy Clothing',
        surface:'Surface Description',
        specialProcess:'Special Process Description',
        follow:'Follow us'
    }   
}